import Backbone from 'backbone';
import ProductView from 'views/store/themes/livingdirect/pages/products/show.page';
const plaView = Backbone.View.extend({
	events: {
		'click .js-review-trigger': '_handleWriteReviewClick',
		'click .js-rating-link': '_handleWriteReviewClick',
		'click .js-full-product-page': '_trackFullPageClick'
	},
	el: 'body',
	initialize: function() {
		this.childViews.product = new ProductView();
		this.fullProdPageUrl = $('.js-full-product-page').data('location');
	},
	_trackFullPageClick: function(e) {
		e.preventDefault();
		Backbone.trigger('omniture:plaPageToFullProductPage');
		window.location.assign(window.BCOM.util.updateURLParameters(this.fullProdPageUrl, 'uid', window.dataLayer.selectedFinishId));
	},
	_handleWriteReviewClick: function(event) {
		event.stopPropagation();
		event.preventDefault();
		window.location.assign(
			`${window.BCOM.util.updateURLParameters(this.fullProdPageUrl, 'uid', window.dataLayer.selectedFinishId)}#reviews`
		);
	}
});
export default plaView;
